import {styled} from 'styled-components';

export const Wrapper = styled.div`
    max-width: ${(props): string =>
        `${props.theme.desktopMeasures.centeredContentWidth}${props.theme.unitsOfMeasure.px}`};
    margin: 0 auto;
`;
